"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Dom = require("../_utils/Dom");

var _Button = _interopRequireDefault(require("../Button"));

var _locale = _interopRequireDefault(require("../locale"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _is = require("@utiljs/is");

var _AdvancedPortal = _interopRequireDefault(require("../core/AdvancedPortal"));

var _warning = _interopRequireDefault(require("warning"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ModalStatus = {
  info: 'info',
  success: 'success',
  danger: 'danger',
  question: 'question'
};

var Modal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = _super.call(this, props);

    _this.handleClose = function (e, type) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          onCancel = _this$props.onCancel;

      if ((0, _is.isFunction)(onClose)) {
        onClose(e, type);
      }

      if ((0, _is.isFunction)(onCancel)) {
        onCancel(e, type);
      }
    };

    _this.handleBtnClose = function (e) {
      _this.handleClose(e, 'button');
    };

    _this.handleIconClose = function (e) {
      _this.handleClose(e, 'closeIcon');
    };

    _this.handleMaskClick = function (event) {
      var backdropClosable = _this.props.backdropClosable;

      if (!backdropClosable) {
        return;
      }

      if (event.target === event.currentTarget) {
        _this.handleClose(event, 'backdrop');
      }
    };

    _this.handleConfirm = function (e) {
      var _this$props2 = _this.props,
          onOpen = _this$props2.onOpen,
          onConfirm = _this$props2.onConfirm;

      if ((0, _is.isFunction)(onOpen)) {
        onOpen(e);
      }

      if ((0, _is.isFunction)(onConfirm)) {
        onConfirm(e);
      }
    };

    _this.renderTitle = function () {
      var _this$props3 = _this.props,
          title = _this$props3.title,
          status = _this$props3.status;

      if (title && (!status || status === 'normal')) {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-modal-header"
        }, /*#__PURE__*/React.createElement("h5", {
          className: "roo-modal-title"
        }, title));
      }

      return null;
    };

    _this.renderClose = function () {
      var _this$props4 = _this.props,
          title = _this$props4.title,
          closable = _this$props4.closable;
      return title && closable ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "roo-modal",
        onClick: _this.handleIconClose
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true",
        className: "roo-icon roo-icon-close"
      })) : null;
    };

    _this.renderBody = function () {
      var _this$props5 = _this.props,
          children = _this$props5.children,
          status = _this$props5.status,
          title = _this$props5.title;
      var isStatus = status && ModalStatus[status];
      var bodyCls = (0, _classnames.default)('roo-modal-body', {
        'has-icon': isStatus
      }, status);
      return /*#__PURE__*/React.createElement("div", {
        className: bodyCls
      }, title && isStatus ? /*#__PURE__*/React.createElement("h5", {
        className: "title"
      }, title) : null, children);
    };

    _this.renderFooter = function () {
      var _this$props6 = _this.props,
          closeText = _this$props6.closeText,
          cancelText = _this$props6.cancelText,
          openText = _this$props6.openText,
          confirmText = _this$props6.confirmText,
          showCloseButton = _this$props6.showCloseButton,
          showOpenButton = _this$props6.showOpenButton,
          showConfirmButton = _this$props6.showConfirmButton,
          showCancelButton = _this$props6.showCancelButton,
          closeButtonProps = _this$props6.closeButtonProps,
          cancelButtonProps = _this$props6.cancelButtonProps,
          openButtonProps = _this$props6.openButtonProps,
          confirmButtonProps = _this$props6.confirmButtonProps;
      var off = showCloseButton && showCancelButton;
      var on = showOpenButton && showConfirmButton;

      if (off || on) {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-modal-footer"
        }, off ? /*#__PURE__*/React.createElement(_Button.default, (0, _assign.default)({
          type: "hollow",
          onClick: _this.handleBtnClose
        }, closeButtonProps, cancelButtonProps), cancelText || closeText || _locale.default.lng('Modal.closeText')) : null, on ? /*#__PURE__*/React.createElement(_Button.default, (0, _assign.default)({
          onClick: _this.handleConfirm
        }, openButtonProps, confirmButtonProps), confirmText || openText || _locale.default.lng('Modal.openText')) : null);
      }

      return null;
    };

    if (props.onClose || props.onOpen) {
      (0, _warning.default)(false, 'Roo Modal: 1.0.0 之后 onClose 改为 onCancel, onOpen 改为 onConfirm, 请及时修改 API 名称');
    }

    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.visible) {
        (0, _Dom.disableBodyScroll)();
      } else {
        (0, _Dom.enableBodyScroll)();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.visible) {
        (0, _Dom.enableBodyScroll)();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          visible = _a.visible,
          backdrop = _a.backdrop,
          size = _a.size,
          status = _a.status,
          title = _a.title,
          closable = _a.closable,
          className = _a.className,
          backdropStyle = _a.backdropStyle,
          backdropClosable = _a.backdropClosable,
          lazy = _a.lazy,
          container = _a.container,
          popupContainer = _a.popupContainer,
          zIndex = _a.zIndex,
          restProps = __rest(_a, ["visible", "backdrop", "size", "status", "title", "closable", "className", "backdropStyle", "backdropClosable", "lazy", "container", "popupContainer", "zIndex"]);

      var rest = (0, _omit.default)(restProps, ['closeText', 'openText', 'onClose', 'confirmText', 'cancelText', 'onConfirm', 'onCancel', 'showCancelButton', 'showConfirmButton', 'confirmButtonProps', 'cancelButtonProps', 'onOpen', 'showCloseButton', 'showOpenButton', 'closeButtonProps', 'openButtonProps', 'backdropClosable']);
      var wrapCls = (0, _classnames.default)('roo-modal', {
        backdrop: backdrop
      });
      var wrapStyle = !backdrop ? {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate3d(-50%, -50%, 0)'
      } : backdropStyle || {};
      var modalCls = (0, _classnames.default)('roo-modal-dialog', (0, _defineProperty2.default)({}, "roo-modal-".concat(size), size), className);
      var contentCls = (0, _classnames.default)('roo-modal-content');
      return /*#__PURE__*/React.createElement(_AdvancedPortal.default, {
        zIndex: zIndex,
        visible: visible,
        lazy: lazy,
        container: container || popupContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: wrapCls,
        style: wrapStyle,
        onClick: this.handleMaskClick
      }, /*#__PURE__*/React.createElement("div", (0, _assign.default)({
        className: modalCls
      }, rest), /*#__PURE__*/React.createElement("div", {
        className: contentCls
      }, this.renderTitle(), this.renderBody(), this.renderFooter(), this.renderClose()))));
    }
  }]);
  return Modal;
}(React.Component);

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.node,
  status: PropTypes.oneOf(['normal', 'info', 'success', 'danger', 'question']),
  closable: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'default', 'lg']),
  container: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  backdrop: PropTypes.bool,
  backdropClosable: PropTypes.bool,
  backdropStyle: PropTypes.object,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  closeText: PropTypes.string,
  openText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  showCloseButton: PropTypes.bool,
  showOpenButton: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  closeButtonProps: PropTypes.object,
  openButtonProps: PropTypes.object,
  className: PropTypes.string,
  lazy: PropTypes.bool
};
Modal.defaultProps = {
  title: undefined,
  backdrop: true,
  backdropClosable: true,
  status: undefined,
  container: undefined,
  popupContainer: undefined,
  lazy: false,
  size: 'default',
  onClose: undefined,
  onOpen: undefined,
  onCancel: function onCancel() {},
  onConfirm: function onConfirm() {},
  closeText: undefined,
  openText: undefined,
  cancelText: undefined,
  confirmText: undefined,
  closable: true,
  showCloseButton: true,
  showCancelButton: true,
  showOpenButton: true,
  showConfirmButton: true,
  closeButtonProps: null,
  openButtonProps: null,
  backdropStyle: null,
  className: undefined
};
/*
* TODO:
* 增加动画
* 方法中封装状态
* ESC 键盘事件支持
*/

var _default = Modal;
exports.default = _default;